  (function() {
    'use strict';

    let _initialized = false;

    const widgetConfigNode = document.getElementById('moxie-floating-call-widget');
    const MOXIE_TEXTS = {
      successTitle: (widgetConfigNode && widgetConfigNode.dataset.successTitle) || '¡Gracias!',
      successMessage: (widgetConfigNode && widgetConfigNode.dataset.successMessage) || 'Hemos recibido tu solicitud correctamente. Te llamaremos pronto.',
      errorTitle: (widgetConfigNode && widgetConfigNode.dataset.errorTitle) || 'Error',
      submittingText: (widgetConfigNode && widgetConfigNode.dataset.submittingText) || 'Enviando...'
    };

    // Horario de atención del callback: lunes a viernes de 8:00 a 17:00, hora de
    // Colombia (los festivos no se bloquean). Fuera de horario "Te llamamos" no se
    // muestra, ni como botón flotante ni en el menú de ayuda (help-apps-popup.js
    // lee data-fuera-de-horario del botón). Se calcula con la zona de Colombia, no
    // con la del visitante. Fuera de horario no se envía nada: si el formulario
    // está abierto al llegar las 17:00, o se intenta enviar fuera de horario, se
    // muestra el aviso de horario y se cierra todo. La Lambda también rechaza
    // las solicitudes fuera de horario.
    const HORARIO = { zona: 'America/Bogota', dias: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'], inicioMin: 8 * 60, finMin: 17 * 60 };
    const AVISO_FUERA_DE_HORARIO = {
      titulo: 'Fuera de horario',
      texto: 'Nuestro horario de atención es de lunes a viernes de 8:00 a 17:00 (hora de Colombia). Escríbenos en ese horario y te llamaremos.'
    };
    const AVISO_SEGUNDOS = 5;

    function dentroDeHorario(fecha) {
      try {
        const partes = {};
        new Intl.DateTimeFormat('en-US', { timeZone: HORARIO.zona, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(fecha || new Date())
          .forEach(function(p) { partes[p.type] = p.value; });
        const minutos = Number(partes.hour) * 60 + Number(partes.minute);
        return HORARIO.dias.indexOf(partes.weekday) !== -1 && minutos >= HORARIO.inicioMin && minutos < HORARIO.finMin;
      } catch (e) {
        // Navegador sin zonas horarias: se muestra el botón (la Lambda cubre fuera de horario).
        return true;
      }
    }

    function initFloatingButton() {
      if (_initialized) return;

      const widget = document.getElementById('moxie-floating-call-widget');
      const button = document.getElementById('moxie-floating-call-button');
      const popup = document.getElementById('moxie-floating-call-popup');

      if (!widget || !button || !popup) {
        setTimeout(initFloatingButton, 200);
        return;
      }

      _initialized = true;
      const closeButton = document.getElementById('moxie-floating-call-close');
      const actionButton = document.getElementById('moxie-floating-call-action');

      widget.style.cssText = 'position: fixed !important; z-index: 999999 !important; bottom: 200px !important; right: 20px !important; display: block !important; visibility: visible !important; opacity: 1 !important; pointer-events: auto !important; width: auto !important; height: auto !important; overflow: visible !important;';
      button.style.cssText = 'display: flex !important; visibility: visible !important; opacity: 1 !important; background-color: #00A859 !important; color: white !important; border: none !important; padding: 12px 20px !important; border-radius: 50px !important; cursor: pointer !important;';
      // Solo ocultar el botón flotante si el slot de callback está activo en el popup de ayudas.
      // Si el slot no existe (checkbox desactivado), el botón vive en su posición nativa.
      if (document.querySelector('[data-help-native-slot="callback"]')) {
        button.style.setProperty('display', 'none', 'important');
      } else {
        button.style.removeProperty('display');
      }
      
      // Mostrar u ocultar según el horario. Se revisa cada 15 s para que el botón
      // aparezca a las 8:00 y desaparezca a las 17:00 sin recargar la página.
      // Se arranca al final de initFloatingButton, cuando ya existen las vistas del popup.
      let _cierrePorHorario = null;

      function ocultarWidget() {
        widget.style.setProperty('display', 'none', 'important');
      }

      function aplicarHorario() {
        const abierto = dentroDeHorario();
        button.setAttribute('data-fuera-de-horario', abierto ? 'false' : 'true');
        if (abierto) {
          if (!_cierrePorHorario) widget.style.setProperty('display', 'block', 'important');
          return;
        }
        // Con el popup abierto se avisa del horario y se cierra todo; si no, se oculta ya.
        if (popup.getAttribute('aria-hidden') === 'false') {
          avisarFueraDeHorario();
        } else if (!_cierrePorHorario) {
          ocultarWidget();
        }
      }

      // Muestra el aviso de horario en el popup y, pasados unos segundos para
      // que se alcance a leer, cierra el popup y oculta el botón.
      function avisarFueraDeHorario() {
        if (_cierrePorHorario) return;
        showErrorMessage(AVISO_FUERA_DE_HORARIO.titulo, AVISO_FUERA_DE_HORARIO.texto);
        _cierrePorHorario = setTimeout(function() {
          _cierrePorHorario = null;
          showInitialView();
          closePopup();
          ocultarWidget();
        }, AVISO_SEGUNDOS * 1000);
      }

      // Forzar visibilidad también en los elementos hijos
      const buttonText = button.querySelector('.moxie-floating-call-button__text');
      const buttonIcon = button.querySelector('.moxie-floating-call-button__icon');
      if (buttonText) {
        buttonText.style.cssText = 'display: inline !important; visibility: visible !important; opacity: 1 !important;';
      }
      if (buttonIcon) {
        buttonIcon.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; width: 20px !important; height: 20px !important;';
      }

      // Crear overlay si no existe
      let overlay = document.querySelector('.moxie-floating-call-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'moxie-floating-call-overlay';
        document.body.appendChild(overlay);
      }

      // Abrir el popup
      function openPopup() {
        popup.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        if (overlay) overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }

      // Referencias a las vistas (declarar antes de closePopup)
      const initialView = document.getElementById('moxie-popup-initial-view');
      const formView = document.getElementById('moxie-popup-form-view');
      const messageView = document.getElementById('moxie-popup-message-view');
      const callForm = document.getElementById('moxie-call-form');
      const formBackButton = document.getElementById('moxie-form-back');
      const formLoading = document.getElementById('moxie-form-loading');
      const messageTitle = document.getElementById('moxie-message-title');
      const messageText = document.getElementById('moxie-message-text');
      const messageIcon = document.getElementById('moxie-message-icon');
      const messageCloseButton = document.getElementById('moxie-message-close');

      // Mostrar el formulario
      function showForm() {
        if (initialView && formView && messageView) {
          initialView.style.display = 'none';
          formView.style.display = 'flex';
          messageView.style.display = 'none';
        }
      }

      // Volver a la vista inicial
      function showInitialView() {
        if (initialView && formView && messageView) {
          formView.style.display = 'none';
          messageView.style.display = 'none';
          initialView.style.display = 'flex';
          // Limpiar el formulario
          if (callForm) {
            callForm.reset();
          }
        }
      }

      // Mostrar mensaje de éxito
      function showSuccessMessage(title, message) {
        if (initialView && formView && messageView && messageTitle && messageText && messageIcon) {
          // Ocultar otras vistas
          initialView.style.display = 'none';
          formView.style.display = 'none';
          
          // Configurar mensaje de éxito
          messageTitle.textContent = title || '¡Gracias!';
          messageText.textContent = message || 'Hemos recibido tu solicitud correctamente.';
          messageIcon.className = 'moxie-message-icon moxie-message-icon--success';
          
          // Mostrar vista de mensaje
          messageView.style.display = 'flex';
        }
      }

      // Mostrar mensaje de error
      function showErrorMessage(title, message) {
        if (initialView && formView && messageView && messageTitle && messageText && messageIcon) {
          // Ocultar otras vistas
          initialView.style.display = 'none';
          formView.style.display = 'none';
          
          // Configurar mensaje de error
          messageTitle.textContent = title || 'Error';
          messageText.textContent = message || 'Hubo un error al procesar tu solicitud.';
          messageIcon.className = 'moxie-message-icon moxie-message-icon--error';
          
          // Mostrar vista de mensaje
          messageView.style.display = 'flex';
        }
      }

      // Cerrar el popup
      function closePopup() {
        showInitialView(); 
        popup.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-expanded', 'false');
        if (overlay) overlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      // Callback opcional a ejecutar cuando el usuario pulsa "Volver" desde el formulario.
      let _onFormBack = null;

      // API pública para abrir este flujo desde otros widgets (popup de ayudas).
      window.MoxieFloatingCallWidget = {
        open: openPopup,
        close: closePopup,
        openForm: function(onBack) {
          _onFormBack = (typeof onBack === 'function') ? onBack : null;
          showForm();   // primero fija la vista del formulario en el DOM
          openPopup();  // luego revela el popup (la transición CSS ya muestra el formulario)
        },
        openInitial: function() {
          _onFormBack = null;
          showInitialView();
          openPopup();
        }
      };

      // Event listeners
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        const isOpen = popup.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          closePopup();
        } else {
          openPopup();
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          closePopup();
        });
      }

      // Cerrar al hacer clic en el overlay
      if (overlay) {
        overlay.addEventListener('click', function(e) {
          e.stopPropagation();
          closePopup();
        });
      }

      // Cerrar al presionar Escape
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
          closePopup();
        }
      });

      // Prevenir que el clic en el popup lo cierre
      popup.addEventListener('click', function(e) {
        e.stopPropagation();
      });


      // Acción del botón "Te llamamos"
      if (actionButton) {
        actionButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          showForm();
        });
      }

      // Botón para volver atrás
      if (formBackButton) {
        formBackButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          if (typeof _onFormBack === 'function') {
            var cb = _onFormBack;
            _onFormBack = null;
            closePopup();
            cb();
          } else {
            showInitialView();
          }
        });
      }

      // Botón para cerrar el mensaje
      if (messageCloseButton) {
        messageCloseButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          showInitialView();
          closePopup();
        });
      }

      // Validar formato de teléfono colombiano (10 dígitos)
      function validatePhone(phone) {
        // Remover espacios y caracteres no numéricos
        const cleanPhone = phone.replace(/\D/g, '');
        // Debe tener exactamente 10 dígitos
        return cleanPhone.length === 10 && /^[0-9]{10}$/.test(cleanPhone);
      }

      function setFormLoadingState(isLoading, submitButton, originalText) {
        if (callForm) {
          callForm.setAttribute('aria-busy', isLoading ? 'true' : 'false');
          const controls = callForm.querySelectorAll('input, button');
          controls.forEach(function(control) {
            control.disabled = isLoading;
          });
        }

        if (submitButton) {
          submitButton.textContent = isLoading ? MOXIE_TEXTS.submittingText : originalText;
        }

        if (formLoading) {
          formLoading.classList.toggle('is-active', isLoading);
          formLoading.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
        }
      }

      // Utilidades para robustecer la petición ante fallos transitorios
      const REQUEST_CONFIG = {
        timeoutMs: 12000,
        maxRetries: 1,
        initialRetryDelayMs: 800
      };

      function wait(ms) {
        return new Promise(function(resolve) {
          setTimeout(resolve, ms);
        });
      }

      function fetchWithTimeout(url, options, timeoutMs) {
        const controller = new AbortController();
        const timer = setTimeout(function() {
          controller.abort();
        }, timeoutMs);

        return fetch(url, Object.assign({}, options, { signal: controller.signal }))
          .finally(function() {
            clearTimeout(timer);
          });
      }

      function shouldRetryRequest(error) {
        // Reintentar solo en timeout, error de red o errores 5xx
        return !!(error && (error.isTimeout || error.isNetworkError || error.isServerError));
      }

      function submitConsultRequest(payload) {
        var apiNegocio = (widgetConfigNode && widgetConfigNode.dataset.apiNegocio) || 'MCENTER';
        var apiPais    = (widgetConfigNode && widgetConfigNode.dataset.apiPais)    || 'COL';

        return fetchWithTimeout('https://uripgq2aeot32wojigzatop5wu0zvewq.lambda-url.us-east-2.on.aws/api/consultar-servicio', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nombre:        payload.nombre,
            telefono:      payload.telefono,
            negocio:       apiNegocio,
            pais:          apiPais,
            aceptaTerminos: payload.aceptaTerminos
          })
        }, REQUEST_CONFIG.timeoutMs)
          .then(function(response) {
            if (response.status >= 500) {
              const serverError = new Error('Error temporal del servidor. Status: ' + response.status);
              serverError.isServerError = true;
              throw serverError;
            }

            if (response.status !== 200) {
              throw new Error('Error en la respuesta del servidor. Status: ' + response.status);
            }

            return response.json().then(function(data) {
              if (data && data.success === true) {
                return data;
              }

              const errorMensaje = data && data.mensaje ? data.mensaje : 'No se pudo procesar tu solicitud.';
              const error = new Error(errorMensaje);
              // La Lambda marca así el rechazo por horario (p. ej. reloj del dispositivo mal puesto).
              if (data && data.fueraDeHorario) error.fueraDeHorario = true;
              throw error;
            });
          })
          .catch(function(error) {
            if (error && error.name === 'AbortError') {
              const timeoutError = new Error('La solicitud tardó demasiado tiempo.');
              timeoutError.isTimeout = true;
              throw timeoutError;
            }

            if (error instanceof TypeError) {
              const networkError = new Error('Error de conexión temporal.');
              networkError.isNetworkError = true;
              throw networkError;
            }

            throw error;
          });
      }

      function submitConsultRequestWithRetry(payload) {
        let attempt = 0;

        function execute() {
          return submitConsultRequest(payload).catch(function(error) {
            const canRetry = attempt < REQUEST_CONFIG.maxRetries && shouldRetryRequest(error);
            if (!canRetry) {
              throw error;
            }

            attempt += 1;
            const retryDelay = REQUEST_CONFIG.initialRetryDelayMs * attempt;
            return wait(retryDelay).then(execute);
          });
        }

        return execute();
      }

      // Manejar el envío del formulario
      if (callForm) {
        callForm.addEventListener('submit', function(e) {
          e.stopPropagation();
          e.preventDefault();

          // Fuera de horario no se envía nada (por ejemplo, formulario abierto antes de las 17:00).
          if (!dentroDeHorario()) {
            avisarFueraDeHorario();
            return;
          }

          const nameInput = document.getElementById('moxie-call-name');
          const phoneInput = document.getElementById('moxie-call-phone');
          const submitButton = document.getElementById('moxie-form-submit');
          
          if (nameInput && phoneInput) {
            const name = nameInput.value.trim();
            const phone = phoneInput.value.trim();
            
            // Validar campos
            if (!name) {
              showErrorMessage('{{ error_title }}', 'Por favor ingresa tu nombre completo.');
              nameInput.focus();
              return;
            }

            if (!phone) {
              showErrorMessage('{{ error_title }}', 'Por favor ingresa tu número de teléfono.');
              phoneInput.focus();
              return;
            }

            // Validar formato del teléfono
            if (!validatePhone(phone)) {
              showErrorMessage('{{ error_title }}', 'Por favor ingresa un número de teléfono válido de 10 dígitos (ejemplo: 3001234567).');
              phoneInput.focus();
              return;
            }

            const cleanPhone = phone.replace(/\D/g, '');

            // Validar aceptación de T&C si está habilitado
            var termsEnabled = widgetConfigNode && widgetConfigNode.dataset.termsEnabled === 'true';
            var termsCheck = document.getElementById('moxie-terms-check');
            if (termsEnabled) {
              if (termsCheck && !termsCheck.checked) {
                termsCheck.classList.add('moxie-terms--error');
                termsCheck.focus();
                termsCheck.addEventListener('change', function() {
                  termsCheck.classList.remove('moxie-terms--error');
                }, { once: true });
                return;
              }
            }

            // Mostrar estado de carga visible mientras se envía
            if (submitButton) {
              const originalText = submitButton.textContent;
              setFormLoadingState(true, submitButton, originalText);

              submitConsultRequestWithRetry({
                nombre: name,
                telefono: cleanPhone,
                aceptaTerminos: termsEnabled ? !!(termsCheck && termsCheck.checked) : false
              })
              .then(function(data) {
                // Si la Lambda envía su propio mensaje (p. ej. fuera de horario:
                // "te llamaremos el siguiente día hábil"), se muestra ese en lugar del genérico.
                const mensajeLambda = data && data.mensaje;
                const successMessage = mensajeLambda || (MOXIE_TEXTS.successMessage + ' Te llamaremos pronto al ' + cleanPhone + '.');
                let successTitle = MOXIE_TEXTS.successTitle;
                if (successTitle.includes('{{name}}')) {
                  successTitle = successTitle.replace(/\{\{name\}\}/g, name);
                } else {
                  successTitle = '¡Gracias ' + name + '!';
                }
                showSuccessMessage(successTitle, successMessage);

                // Cerrar el popup después de 3 segundos (6 si es el mensaje de la Lambda, para que alcance a leerse)
                setTimeout(function() {
                  showInitialView();
                  closePopup();
                }, mensajeLambda ? 6000 : 3000);
              })
              .catch(function(error) {
                if (error && error.fueraDeHorario) {
                  avisarFueraDeHorario();
                  return;
                }
                console.error('Error al enviar formulario:', error);
                const genericMessage = 'Hubo un error al enviar tus datos. Por favor intenta de nuevo más tarde.';
                const errorMessage = error && error.message ? error.message : genericMessage;
                showErrorMessage(MOXIE_TEXTS.errorTitle, errorMessage);
              })
              .finally(function() {
                // Restaurar botón
                setFormLoadingState(false, submitButton, originalText);
              });
            }
          }
        });
      }

      // Validar teléfono mientras el usuario escribe (solo números)
      const phoneInput = document.getElementById('moxie-call-phone');
      if (phoneInput) {
        phoneInput.addEventListener('input', function(e) {
          // Solo permitir números
          this.value = this.value.replace(/\D/g, '');
          
          // Limitar a 10 dígitos
          if (this.value.length > 10) {
            this.value = this.value.slice(0, 10);
          }
        });

        // Validar al perder el foco
        phoneInput.addEventListener('blur', function(e) {
          const value = this.value.replace(/\D/g, '');
          if (value && value.length !== 10) {
            this.style.borderColor = '#e74c3c';
          } else {
            this.style.borderColor = '';
          }
        });
      }

      aplicarHorario();
      setInterval(aplicarHorario, 15000);
    }

    // Múltiples estrategias para asegurar la ejecución
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initFloatingButton, 50);
      });
    } else {
      // DOM ya está listo
      setTimeout(initFloatingButton, 50);
    }

    // También intentar después de que la ventana esté completamente cargada
    window.addEventListener('load', function() {
      setTimeout(initFloatingButton, 100);
    });

    // Último intento después de un delay más largo
    setTimeout(initFloatingButton, 500);
  })();
